const labels = {
  All: { 'See the offering': 'Zobacz ofertę' },
  FacilityDetails: { 'Ref: Page title': 'Szczegóły obiektu', 'Ref: Review': 'Recenzja' },
  FacilitiesList: { 'Ref: Page title': 'Obiekty', 'Ref: See details': 'Zobacz szczegóły' },
};
export default labels;
